/**
 * @generated SignedSource<<c0c89620b586721d30f6c870d2966e11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActionItemIntegrationSyncStatus = "CREATING_EXTERNALLY" | "DONE_SYNCING_EXTERNALLY" | "FAILED_TO_SYNC_EXTERNALLY" | "SENDING_UPDATE_EXTERNALLY";
export type IntegrationProvider = "ASANA" | "CLICKUP" | "HUBSPOT_TASK" | "JIRA" | "LINEAR" | "MICROSOFT_TODO" | "MONDAY" | "TRELLO";
export type actionItemIntegrationLinkQuery$variables = {
  id: string;
};
export type actionItemIntegrationLinkQuery$data = {
  readonly node: {
    readonly actionItemIntegrationLink?: {
      readonly actionItem: {
        readonly id: string;
        readonly key: string;
        readonly originalBlockId: string | null;
      };
      readonly createdAt: string | null;
      readonly id: string;
      readonly integrationData: {
        readonly __typename: "ClickupActionItemIntegrationSpecificDataNode";
        readonly externalTaskId: string;
        readonly listName: string;
        readonly status: string;
        readonly statusColor: string;
      } | {
        readonly __typename: "HubspotTaskActionItemIntegrationSpecificDataNode";
        readonly externalTaskId: string;
        readonly hubspotUrl: string;
      } | {
        readonly __typename: "LinearActionItemIntegrationSpecificDataNode";
        readonly externalIdentifier: string | null;
        readonly linearUser: {
          readonly id: string;
          readonly isConnected: boolean;
          readonly organizationUrlKey: string;
        };
        readonly statusColor: string;
        readonly statusName: string;
        readonly teamName: string;
      } | {
        readonly __typename: "MicrosoftTodoActionItemIntegrationSpecificDataNode";
        readonly externalListId: string;
        readonly externalListName: string;
        readonly externalTaskId: string;
        readonly microsoftTodoUser: {
          readonly isConnected: boolean;
        };
        readonly status: string;
      } | {
        readonly __typename: "MondayActionItemIntegrationSpecificDataNode";
        readonly externalBoardId: string;
        readonly externalBoardName: string;
        readonly externalGroupName: string;
        readonly externalTaskId: string;
        readonly mondayUser: {
          readonly accountSlug: string;
        };
        readonly status: string;
      } | {
        readonly __typename: "TrelloActionItemIntegrationSpecificDataNode";
        readonly boardName: string;
        readonly externalCardId: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      };
      readonly integrationProvider: IntegrationProvider;
      readonly lastSyncedError: string | null;
      readonly syncStatus: ActionItemIntegrationSyncStatus;
      readonly updatedAt: string | null;
    } | null;
    readonly id?: string;
    readonly key?: string;
  } | null;
};
export type actionItemIntegrationLinkQuery = {
  response: actionItemIntegrationLinkQuery$data;
  variables: actionItemIntegrationLinkQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteBlock",
  "kind": "LinkedField",
  "name": "actionItem",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "originalBlockId",
      "storageKey": null
    },
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "syncStatus",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSyncedError",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationProvider",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalTaskId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "listName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusColor",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalCardId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "boardName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalGroupName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalBoardId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalBoardName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountSlug",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalIdentifier",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamName",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusName",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "LinearUserNode",
  "kind": "LinkedField",
  "name": "linearUser",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v24/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organizationUrlKey",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalListId",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalListName",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hubspotUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "actionItemIntegrationLinkQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ActionItemIntegrationLinkNode",
                "kind": "LinkedField",
                "name": "actionItemIntegrationLink",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "integrationData",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/)
                        ],
                        "type": "ClickupActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/)
                        ],
                        "type": "TrelloActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MondayUserNode",
                            "kind": "LinkedField",
                            "name": "mondayUser",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MondayActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v14/*: any*/),
                          (v25/*: any*/)
                        ],
                        "type": "LinearActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MicrosoftTodoUserNode",
                            "kind": "LinkedField",
                            "name": "microsoftTodoUser",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MicrosoftTodoActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v28/*: any*/)
                        ],
                        "type": "HubspotTaskActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "NoteBlock",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "actionItemIntegrationLinkQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ActionItemIntegrationLinkNode",
                "kind": "LinkedField",
                "name": "actionItemIntegrationLink",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "integrationData",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/)
                        ],
                        "type": "ClickupActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/)
                        ],
                        "type": "TrelloActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v11/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MondayUserNode",
                            "kind": "LinkedField",
                            "name": "mondayUser",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MondayActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v14/*: any*/),
                          (v25/*: any*/)
                        ],
                        "type": "LinearActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v11/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MicrosoftTodoUserNode",
                            "kind": "LinkedField",
                            "name": "microsoftTodoUser",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MicrosoftTodoActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v11/*: any*/),
                          (v28/*: any*/)
                        ],
                        "type": "HubspotTaskActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "NoteBlock",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2bd50caa8ecb09be8bb37097a0fbca73",
    "id": null,
    "metadata": {},
    "name": "actionItemIntegrationLinkQuery",
    "operationKind": "query",
    "text": "query actionItemIntegrationLinkQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on NoteBlock {\n      id\n      key\n      actionItemIntegrationLink {\n        id\n        actionItem {\n          originalBlockId\n          id\n          key\n        }\n        createdAt\n        updatedAt\n        syncStatus\n        lastSyncedError\n        integrationProvider\n        integrationData {\n          __typename\n          ... on ClickupActionItemIntegrationSpecificDataNode {\n            __typename\n            externalTaskId\n            listName\n            status\n            statusColor\n          }\n          ... on TrelloActionItemIntegrationSpecificDataNode {\n            __typename\n            externalCardId\n            boardName\n          }\n          ... on MondayActionItemIntegrationSpecificDataNode {\n            __typename\n            externalTaskId\n            externalGroupName\n            externalBoardId\n            externalBoardName\n            status\n            mondayUser {\n              accountSlug\n              id\n            }\n          }\n          ... on LinearActionItemIntegrationSpecificDataNode {\n            __typename\n            externalIdentifier\n            teamName\n            statusName\n            statusColor\n            linearUser {\n              id\n              isConnected\n              organizationUrlKey\n            }\n          }\n          ... on MicrosoftTodoActionItemIntegrationSpecificDataNode {\n            __typename\n            externalTaskId\n            externalListId\n            externalListName\n            status\n            microsoftTodoUser {\n              isConnected\n              id\n            }\n          }\n          ... on HubspotTaskActionItemIntegrationSpecificDataNode {\n            __typename\n            externalTaskId\n            hubspotUrl\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "73ed232d0c4cb71cebef7dbdd1d6b9ba";

export default node;
